/**
 * The "start this campaign?" prompt shown when leads are assigned and sent out into a campaign that
 * is not sending yet (PREC-3296). Its own file because en.ts is at the size ratchet.
 *
 * The wording is per campaign, not per list: starting is a per-campaign write, and a list-wide
 * "activate outreach" would also start every other campaign on the list.
 */
export const enOutreachActivation = {
	title_one: "Start the campaign?",
	title_other: "Start these campaigns?",
	intro_one: "The campaign you are assigning to is not sending yet:",
	intro_other: "The campaigns you are assigning to are not sending yet:",
	/** A campaign's own run state, shown on the prompt and on the Review-to-send picker. */
	campaignState: {
		active: "Active",
		starting: "Starting",
		notStarted: "Not started",
		paused: "Paused",
		ended: "Ended",
		invalid: "Invalid",
	},
	alreadyAssigned_one: "{{count}} lead already assigned will be contacted as well.",
	alreadyAssigned_other: "{{count}} leads already assigned will be contacted as well.",
	explainer:
		"Assigned leads are only contacted once their campaign is running. Other campaigns on this list are not affected.",
	startAndAssign_one: "Start campaign & assign",
	startAndAssign_other: "Start campaigns & assign",
	assignOnly: "Assign only",
	failedTitle: "Leads assigned, but not every campaign started",
	failedIntro: "Your leads were assigned. These campaigns could not be started:",
	failedHint: "Start them from the Campaigns column on the Lists page once the problem is fixed.",
	failedFallback: "The request was refused.",
	ok: "OK",
	noValidCampaigns: "No valid campaigns in this list yet.",
};
